import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init } from './modules'
import Loading from 'components/Loading'
import { languageChange, checkExistAppeal } from 'store/siteConfig'

export default function(route) {
  const Order = Loadable({
    loader: () => import('./Order'),
    render(loaded, props) {
      const Component = connect(
        (state) => ({
          riskUnauthOrderState: state.riskUnauthOrderState,
          siteConfig: state.siteConfig
        }),
        {
          init,
          languageChange,
          checkExistAppeal
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/order`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <Order {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
